module.exports = __webpack_public_path__ + "img/undraw_web_developer_p3e5.4b2f2525.svg";